import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIRequest } from '../../../common/Common';
import { getTotal, sanitizeList } from '../../../common/Util';
import { TARGET_YEAR_API } from '../../../common/data';
// import { filterNonItemList } from './util';

const initialState = {
  isRender: false,
  reload: -1,
  dataList: [],
  //공제 불가 항목
  nonItemList: [],
  //원본데이터
  originalDataList: [],

  // 합계
  total: 0,
  //기부금 상세
  donationDetail: [],

  selectedDonationDetail: {},
  detailReload: -1,
  initDonationDetail: {
    htm001: '', //사업자번호
    htm016: '2', //국세청구분 (국세청외가 기본)
    htm005: '', //구분코드
    htm002: '', //상호
    htm003: '', //기부내용
    htm008: '', //기부일
    htm009: '', //일련번호
    htm006: '', //건수
    htm007: '', //금액
    htm027: '', //전년도 공제액
    htm028: '', //이월된 기부금
    htm031: '', //기부장려금
    htmSeq: '',
    htmPerType: '',
    htmPDFSeq: '',
  },
};

//기부금 불러오기
export const getDonationInfo = createAsyncThunk('donation/getDonationInfo', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S8`);
  return response;
});

//기부금 저장
export const updateDonationInfo = createAsyncThunk('donation/updateDonationInfo', async data => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S8S1E`, data);
  return response;
});

//기부금 상세 불러오기
export const getDonationDetail = createAsyncThunk('donation/getDonationDetail', async data => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S8S1`, data);
  return response;
});

//기부금 삭제
export const deleteDonationInfo = createAsyncThunk('donation/deleteDonationInfo', async data => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S8S1D`, data);
  return response;
});

const donationSlice = createSlice({
  name: 'donationSlice',
  initialState,
  reducers: {
    confirmDelete: (state, action) => {
      const { index } = action.payload;
      state.dataList = state.dataList.filter((_, idx) => idx !== index);
    },
    setSelectedDonationDetail: (state, action) => {
      state.selectedDonationDetail = action.payload;
    },
    setReload: (state, action) => {
      state.reload = Math.random();
    },
    setDetailReload: (state, action) => {
      state.detailReload = action.payload;
    },

    resetDonationState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(getDonationInfo.pending, state => {
      // state.dataList = [];
      // state.nonItemList = [];
      state.isRender = false;
    });
    builder.addCase(getDonationInfo.fulfilled, (state, action) => {
      console.log('기부금 리스트 >>', action.payload);
      const { list } = action.payload;
      if (list && list.length > 0) {
        state.dataList = list;
        let totalList = list.filter(item => {
          return item.deType == '1';
        });
        state.total = getTotal(totalList, ['htm030', 'htm060', 'htm067', 'htm069']);
      } else {
        state.dataList = [];
        state.total = 0;
      }
      state.isRender = true;
    });

    builder.addCase(updateDonationInfo.fulfilled, (state, action) => {
      console.log('기부금 저장 성공 >>', action.payload);
      const { resultCode } = action.payload;
      if (resultCode === 'OK') {
        state.reload = Math.random();
      }
    });

    builder.addCase(getDonationDetail.fulfilled, (state, action) => {
      console.log('기부금 상세 성공 >>', action.payload);
      const { list } = action.payload;
      if (list) {
        state.donationDetail = sanitizeList(list);
      } else {
        state.donationDetail = [];
      }
    });

    builder.addCase(deleteDonationInfo.fulfilled, (state, action) => {
      console.log('기부금 삭제 성공 >>', action.payload);
      const { resultCode } = action.payload;
      if (resultCode && resultCode == 'OK') {
        state.reload = Math.random();
        state.detailReload = Math.random();
      }
    });
  },
});

export const {
  confirmDelete,
  resetDonationState,
  setSelectedDonationDetail,
  setReload,
  setDetailReload,
} = donationSlice.actions;
export default donationSlice.reducer;
